import Vue from 'vue'

import {
  Toast,
  Loading,
  Button,
  Icon,
  List,
  Dialog,
  Input,
  Popup,
  Checkbox,
  LazyLoad,
  CheckboxGroup,
  Linkage,
  Cell,
  Picker,
  NumberKeyboard,
  PullRefresh,
  Badge,
  Switch,
  NavBar,
  Tab,
  Tabs,
  ImagePreview
} from 'fs-ui'
import FbHead from '@/components/FbHead/index.vue'

Vue.component('FsIcon', Icon)
Vue.component('FsToast', Toast)
Vue.component('FsLoading', Loading)
Vue.component('FsButton', Button)
Vue.component('FsList', List)
Vue.component('FsInput', Input)
Vue.component('FsCheckbox', Checkbox)
Vue.component('FsCheckboxGroup', CheckboxGroup)
Vue.component('FsLinkage', Linkage)
Vue.component('FsPopup', Popup)
Vue.component('FsCell', Cell)
Vue.component('FsNumberKeyboard', NumberKeyboard)
Vue.component('FsBadge', Badge)
Vue.component('FsPicker', Picker)
Vue.component('FsPullRefresh', PullRefresh)
Vue.component('FsSwitch', Switch)
Vue.component('FbHead', FbHead)
Vue.component('FsNavBar', NavBar)
Vue.component('FsTab', Tab)
Vue.component('FsTabs', Tabs)

Vue.use(LazyLoad, {
  lazyComponent: true
})
Vue.use(Dialog)
Vue.use(ImagePreview)
Vue.prototype.$toast = Toast
Vue.prototype.$fsDialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
